import React from 'react';
import styled from 'styled-components';
import { device } from 'js/config/style';

const KeyFeaturesTitle = styled.h3`
  font-weight: bold;
  text-align: left;
  width: 100%;

  @media(max-width: ${device.laptop}) {
    text-align: center;
  }
`;

export default ({ className, ...rest }) => <KeyFeaturesTitle className={className} {...rest} />;
